import type { BoxProps } from "@mui/material";
import { Box, Skeleton } from "@mui/material";

interface Props {
  containerProps?: BoxProps;
}
export default function AreaFieldItemLoader({ containerProps }: Props) {
  return (
    <Box {...containerProps} sx={{ position: "absolute", width: "100%", ...containerProps?.sx }}>
      <Skeleton
        animation="wave"
        variant="rectangular"
        height={30}
        sx={(theme) => ({ bgcolor: theme.alpha(theme.palette.background.paper, 0.11) })}
      />
    </Box>
  );
}
